
/**
 * 코스 초안 업데이트 요청 (멀티파트폼)
 */
export type UpdateCourseDraftBody = {
  /** 코스 정보 JSON 문자열 */
  data?: string;
  /** 썸네일 이미지 파일 */
  thumbnail?: Blob;
};
